export default __webpack_public_path__ + "static/oksana-remeslova-f3ddf875a895b75aa9a411d2ed10bb15.png";